exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rars--title {\n    cursor: pointer;\n    border-bottom: solid 1px #E0E0E0;\n    width: 100%;\n    min-width: 320px;\n    display: block;\n    padding-bottom: 19px;\n    font-size: 14px;\n    min-height: 14px;\n}\n\n.rars--title.is-active,\n.rars--title:hover {\n    border-bottom: solid 1px #542376;\n}\n\n.rars--title.is-disabled {\n    color: #88857f;\n    cursor: default;\n    border-bottom: solid 1px #E0E0E0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/rars/rars.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/rars/rars.css
// module chunks = 0